import React, { useContext, useEffect } from 'react'
import {
    Card,
    CardBody,
    Container,
    Row,
    Col
} from "reactstrap"

import { withRouter, Link, useParams, Redirect } from 'react-router-dom'
import { GeneralContext } from '../../context/'
import { connect } from "react-redux"

import Personal from './components/Personal'
import Users from './components/_Users'

const Index = (props) => {
    const { route } = useParams() 
    const generalContext = useContext(GeneralContext)
    const { setBreadcrumb } = generalContext

    useEffect(() => {
        setBreadcrumb({
            icon: '',
            parent: 'Configuraciones',
            parentLink: '/settings',
            item: `Configuraciones`
        })

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    useEffect(() => {
        switch(route) {
            case 'users':
                if (props.role !== 'ADMIN') {
                    break
                }
                window.analytics.track('[conf] Ir a Usuarios')
                break;
            case 'personal':
            default:
                window.analytics.track('[conf] Ir a Personal')
                break;
        }
    }, [route, props.role])

    if (route === 'users' && props.role !== 'ADMIN') {
        return <Redirect to="/settings/personal" />
    }

    return(
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    <Card>
                        <CardBody>
                            <Row className="config">
                                <Col className="configuration-nav" md={12} xs={12}>
                                    <nav>
                                        <Link to="/settings/personal" className={route === 'personal' ? 'active' : ''}>Personal</Link>
                                        {props.role === 'ADMIN' && (
                                            <Link to="/users" className={route === 'users' ? 'active' : ''}>Usuarios</Link>
                                        )}
                                    </nav>
                                </Col>
                            </Row>
                        </CardBody>
                    </Card>

                    {route === 'users' ? <Users /> : <Personal />}
                </Container>
            </div>
        </React.Fragment>
    )
}

const mapStatetoProps = (state) => {
    return { role: state.Auth?.profile?.role?.codeName }
}

export default connect(
    mapStatetoProps, {}
)(withRouter(Index))